import { apiClient } from '@/libs/api_client'
import axios from 'axios'

export interface CreateQueueMachineData {
  name: string
  channel: string
  clinic_id: number
  show_patient_name?: boolean
  examination_room_id?: number | null
}

export interface UpdateQueueMachineData {
  name?: string
  channel?: string
  show_patient_name?: boolean
  examination_room_id?: number | null
}

export const queueMachineService = {
  // 獲取所有叫號機
  getAllQueueMachines: async (params: {
    page?: number
    pageSize?: number
    sortBy?: string
    sortOrder?: 'asc' | 'desc'
    token: string
  }) => {
    try {
      const {
        page = 1,
        pageSize = 10,
        sortBy = 'queue_machine_id',
        sortOrder = 'asc',
        token,
      } = params

      const response = await apiClient.get(
        `/api/queue-machines?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UNKNOWN_ERROR',
          message: '取得叫號機列表時發生未知錯誤',
        },
      }
    }
  },

  // 獲取單個叫號機
  getQueueMachineById: async (id: number, token: string) => {
    try {
      const response = await apiClient.get(`/api/queue-machines/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UNKNOWN_ERROR',
          message: '取得叫號機資料時發生未知錯誤',
        },
      }
    }
  },

  // 創建叫號機
  createQueueMachine: async (data: CreateQueueMachineData, token: string) => {
    try {
      const response = await apiClient.post(
        '/api/queue-machines',
        {
          ...data,
          show_patient_name: data.show_patient_name ?? true,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UNKNOWN_ERROR',
          message: '新增叫號機時發生未知錯誤',
        },
      }
    }
  },

  // 更新叫號機
  updateQueueMachine: async (id: number, data: UpdateQueueMachineData, token: string) => {
    try {
      const response = await apiClient.put(`/api/queue-machines/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UNKNOWN_ERROR',
          message: '更新叫號機時發生未知錯誤',
        },
      }
    }
  },

  // 刪除叫號機
  deleteQueueMachine: async (id: number, token: string) => {
    try {
      const response = await apiClient.delete(`/api/queue-machines/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UNKNOWN_ERROR',
          message: '刪除叫號機時發生未知錯誤',
        },
      }
    }
  },
}
